import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIconOption, type IconSet } from "@/components/icons/iconRegistry";

export function IconRenderer({
  value,
  iconSet = "general",
  className,
}: {
  value?: string | null;
  iconSet?: IconSet;
  className?: string;
}) {
  const option = getIconOption(value, iconSet);
  return <FontAwesomeIcon icon={option.icon} className={className} />;
}
